<template>
  <div class="use-box-wrap">
    <ul>
      <li class="use-box-item" tabindex="0" @click="$router.push({ name: 'emarticonRegistration' })">
        <div class="use-item-left">
          <span class="icon-emarticon-card"></span>
          <span class="use-item-text">이마티콘 등록</span>
        </div>
        <span class="icon-chevron-right"></span>
      </li>
      <li v-if="certified && showButton" class="use-box-item" tabindex="0" @click="$router.push({ name: 'setting' })">
        <div class="use-item-left">
          <span class="icon-setup-emarticon"></span>
          <span class="use-item-text">이마티콘 설정</span>
        </div>
        <span class="icon-chevron-right"></span>
      </li>
      <li class="use-box-item" tabindex="0" @click="$router.push({ name: 'emarticonQuestions' })">
        <div class="use-item-left">
          <span class="icon-question"></span>
          <span class="use-item-text">자주하는 질문</span>
        </div>
        <span class="icon-chevron-right"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UseBox',
  props: ['certified'],
  data() {
    return {
      showButton: false,
    }
  },
  mounted() {
    const today = new Date();
    const beginDate = new Date('2025-02-17T00:00:00');

    if(today >= beginDate) {
      this.showButton = true;
    } else {
      if(this.$store.state.mberInfo.mberNo){
        this.showButton = true;
      }
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/common/useBox.scss';
</style>
